import React from "react";

const Usage=()=>{
    return(
        <div className={'flex__center'}>
            <div className={"contents-title-background-box"}>
                <div className={'red-dot-box'}>
                    <div className={'red-dot'}/>
                </div>
                <h3>이용방법</h3>
            </div>
            <div className={"flex__center"}>
                <img src={`${process.env.PUBLIC_URL}/img/usage.jpg`} alt={'usage'} width={"80%"}/>
            </div>
        </div>
    );
}

export default Usage
